import React from 'react';

import {
  Sparkles, Check, Lock, GraduationCap,
} from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import {
  Card, Heading, Text, useToken, HStack, VStack, Center, ButtonText, Icon, Button,
} from '@gluestack-ui/themed';
import ModuleCardLecturer from './ModuleCardLecturer';
import HtmlText from '../../../common/components/HtmlText';

const ModuleCard = ({
  id, title, description, lecturer, state, gradingDueDate, color, handleOpenModule,
}) => {
  const { t } = useTranslation();

  const iconStateMap = {
    active: Sparkles,
    locked: Lock,
    submitted: Check,
    graded: GraduationCap,
  };

  let moduleColor = color;
  if (state === 'locked') {
    moduleColor = 'backgroundLight';
  } else if (state === 'submitted' || state === 'graded') {
    moduleColor = 'blue';
  }

  const ModuleStateIcon = iconStateMap[state];

  return (
    <Card
      testID={`module-card-${id}`}
      $lg-width={370}
      $base-width="100%"
      height={368}
      p={24}
      borderTopLeftRadius={0}
      borderBottomLeftRadius={0}
      borderTopRightRadius={12}
      borderBottomRightRadius={12}
      borderLeftColor={useToken('colors', `${moduleColor}400`)}
      borderLeftWidth={4}
      justifyContent="space-between"
      bg={state === 'locked' ? '$backgroundLight0' : '$white'}
    >
      <VStack flex={1}>
        <HStack testID="module-card-header" justifyContent="space-between" mb={32}>
          <Center
            testID={`module-icon-container-${state}`}
            width={40}
            height={40}
            borderRadius={8}
            bg={useToken('colors', `${moduleColor}400`)}
          >
            <Icon testID={`module-state-icon-${state}`} as={ModuleStateIcon} color="$white" size="lg" />
          </Center>

          <ModuleCardLecturer lecturer={lecturer} />
        </HStack>

        <Heading
          testID={`module-heading-${state}`}
          size="lg"
          numberOfLines={1}
          mb="$1"
          color={state === 'locked' ? '$textLight400' : '$textPrimary'}
        >
          {title}
        </Heading>
        {state === 'submitted' && (
          <Text color="$textLight400" mt={0} mb="$2" fontSize={12}>
            {t('student.course.modulecard.grading-due-date')}
            :
            {' '}
            {gradingDueDate ? new Date(gradingDueDate).toLocaleDateString('en-US') : ''}
          </Text>
        )}
        <HtmlText
          testID={`module-description-${state}`}
          content={description}
          numberOfLines={7}
          fontSize={14}
          color={state === 'locked' ? '$textLight400' : '$textPrimary'}
        />
      </VStack>

      <HStack testID="module-footer" justifyContent="space-between" alignItems="center">
        <HStack>
          {/*
          <Text>{`${numTasks} ${t('student.course.modulecard.tasks')}`}</Text>
        */}
        </HStack>
        {state === 'locked' && (
          <Button
            testID={`unlock-module-${id}`}
            variant="outline"
            action="secondary"
            size="xs"
            onPress={handleOpenModule}
          >
            <ButtonText testID={`button-text-${state}`}>
              {t('student.course.modulecard.button-unlockmodule', { defaultValue: 'Unlock module' })}
            </ButtonText>
          </Button>
        )}
        {!['locked', 'submitted'].includes(state) && (
          <Button
            testID={`open-module-${id}`}
            variant="outline"
            action="secondary"
            size="xs"
            onPress={handleOpenModule}
          >
            <ButtonText testID={`button-text-${state}`}>
              {state === 'graded'
                ? t('student.course.modulecard.button-viewgrade')
                : t('student.course.modulecard.button-openmodule')}
            </ButtonText>
          </Button>
        )}
      </HStack>
    </Card>
  );
};

export default ModuleCard;
